import { CheckboxField, type CheckboxFieldProps } from "$components/inputs";
import React from "react";
import { Controller, useFormContext } from "react-hook-form";

const RHFCheckboxField = (
  props: React.PropsWithoutRef<CheckboxFieldProps> & { name: string },
): React.ReactElement => {
  const { name } = props;
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => {
        const { value, ...restField } = field;
        const error = fieldState?.isTouched
          ? fieldState.error?.message
          : undefined;

        return (
          <CheckboxField
            hideHelper={!error}
            checked={!!value}
            error={error}
            {...restField}
            {...props}
          />
        );
      }}
    />
  );
};

export default RHFCheckboxField;
